import { AxiosPromise, AxiosResponse } from 'axios';
import Resource, { Params } from 'src/services/api-client/resource/base/Resource';
import { EntityFactoryFactory } from 'src/services/entity-factory/EntityFactoryFactory';
import { ClassOf, Entity, FactoryInterface } from 'src/services/entity-factory/FactoryInterface';
import IndexResponse from 'src/value-objects/IndexResponse';

export class TypedResource<T extends Entity> extends Resource {
  private entityFactory: FactoryInterface<T>;

  constructor(route: string, type: ClassOf<T>) {
    super(route);

    const entityFactoryFactory = new EntityFactoryFactory();
    this.entityFactory = entityFactoryFactory.getFactory(type);
  }

  public get(id: number | string, params?: Params): AxiosPromise<T> {
    return super.get(id, params).then((response: AxiosResponse<{}>): AxiosResponse<T> => {
      try {
        response.data = this.entityFactory.toEntity(response.data);
        return response as AxiosResponse<T>;
      } catch (e) {
        // tslint:disable-next-line: no-console
        console.error(e);
        throw e;
      }
    });
  }

  public index(params?: Params): AxiosPromise<IndexResponse<T>> {
    return super.index(params).then((response: AxiosResponse<IndexResponse<{}>>): AxiosResponse<IndexResponse<T>> => {
      try {
        response.data.content = response.data.content.map((element) => this.entityFactory.toEntity(element));
        response.data = new IndexResponse<{}>(response.data) as IndexResponse<T>;
        return response as AxiosResponse<IndexResponse<T>>;
      } catch (e) {
        // tslint:disable-next-line: no-console
        console.error(e);
        throw e;
      }
    });
  }

  public create(entity: T, params?: Params): AxiosPromise {
    return super.create(this.entityFactory.toRequest(entity), params);
  }

  public update(id: number | string, entity: T, params?: Params): AxiosPromise {
    return super.update(id, this.entityFactory.toRequest(entity), params);
  }

}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/base/TypedResource.tsx